import { GoogleAnalytics } from 'nextjs-google-analytics';
import { gaMeasurementId } from '../../@types/IProduct/IProductDetail';

const GoogleAnalyticsComp = () => {
    return <GoogleAnalytics strategy="afterInteractive" gaMeasurementId={gaMeasurementId} />
}

export default GoogleAnalyticsComp;